import { render } from "./BandTable.vue?vue&type=template&id=1c88f018&scoped=true"
import script from "./BandTable.vue?vue&type=script&lang=js"
export * from "./BandTable.vue?vue&type=script&lang=js"

import "./BandTable.vue?vue&type=style&index=0&id=1c88f018&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c88f018"]])

export default __exports__